<template>
	<v-container fluid class="pa-0 form-page-gutter">
		<customer-form v-if="!isUpdating"></customer-form>
		<v-card v-if="isUpdating" elevation="0" class="grey lighten-3">
			<v-card-text
				class="customer-detail-header d-flex align-center justify-space-between flex-wrap flex-md-nowrap flex-lg-nowrap">
				<div v-if="isUpdating" class="customer-summary">
					<div class="customer-title">
						<span class="customer-id blue--text">
							#{{ customer.id }}
						</span>
						<span>{{ customer.name }}</span>
					</div>
					<div class="customer-meta">
						<span v-if="customer.phone">{{ customer.phone }}</span>
						<span
							v-if="
								customer.phone && customer.parentCustomerId
							"
							class="meta-divider">
							|
						</span>
						<span
							v-if="customer.parentCustomerId"
							class="parent-customer">
							Parent:
							<a
								@click="
									$router.push({
										name: 'CustomerUpdate',
										params: {
											id: customer.parentCustomerId,
										},
									})
								">
								{{ getCustomerName(customer.parentCustomerId) }}
							</a>
						</span>
					</div>
				</div>
				<div class="customer-actions">
					<v-btn
						v-if="isUpdating"
						class="mr-2"
						color="primary"
						depressed
						rounded
						@click="customerDialog = true">
						<i class="fas fa-save mr-2"></i>
						Edit Customer
					</v-btn>
					<v-menu rounded offset-y>
						<template v-slot:activator="{ attrs, on }">
							<v-btn
								depressed
								rounded
								color="success"
								v-bind="attrs"
								v-on="on"
								:loading="isLoading">
								<i class="fa-solid fa-caret-down mr-2"></i>
								Actions
							</v-btn>
						</template>

						<v-list>
							<v-list-item link @click="newInvoice">
								<v-list-item-title>
									New Invoice
								</v-list-item-title>
							</v-list-item>
							<v-list-item
								link
								@click="
									$router.push({
										name: 'PaymentPage',
										params: { customerId: customer.id },
									})
								">
								<v-list-item-title>Payment</v-list-item-title>
							</v-list-item>
							<v-list-item link @click="paymentDialog = true">
								<v-list-item-title>
									Add Credit
								</v-list-item-title>
							</v-list-item>
							<v-list-item link @click="generateInvoiceCsv">
								<v-list-item-title>
									Export Invoices
								</v-list-item-title>
							</v-list-item>
							<v-list-item
								v-if="customer.parentCustomerId"
								link
								@click="
									$router.push({
										name: 'CustomerUpdate',
										params: {
											id: customer.parentCustomerId,
										},
									})
								">
								<v-list-item-title>
									Go to Parent Account
								</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</div>
			</v-card-text>
		</v-card>

		<customer-dashboard
			:customer="customer"
			v-if="isUpdating"></customer-dashboard>
		<customer-dialog
			:p-customer="customer"
			:isUpdating="isUpdating"
			v-model="customerDialog"
			@handleChange="(val) => (customer = val)"></customer-dialog>
		<payment-dialog
			v-if="paymentDialog"
			:adding-credit="true"
			:p-customer="customer"
			v-model="paymentDialog"
			@handle-event="addCredit"></payment-dialog>
	</v-container>
</template>
<script>
import backendService from "@/services/backend-service";
import eventBus from "@/js/event-bus";
import generalMixin from "@/js/general-mixin";
import formMixin from "@/js/form-mixin";
import CustomerDashboard from "@/components/CustomerDashboard.vue";
import CustomerDialog from "@/components/CustomerDialog.vue";
import CustomerForm from "@/components/CustomerForm.vue";
import PaymentDialog from "@/components/PaymentDialog.vue";
export default {
	name: "CustomerDetail",
	mixins: [generalMixin, formMixin],
	components: {
		"customer-dashboard": CustomerDashboard,
		"customer-dialog": CustomerDialog,
		"customer-form": CustomerForm,
		"payment-dialog": PaymentDialog,
	},
	mounted: function () {
		if (this.$route.params.id) {
			this.getUpdateForm();
		}
	},
	data() {
		return {
			isLoading: false,
			isUpdating: false,
			customerDialog: false,
			customer: {},
			paymentDialog: false,
		};
	},

	computed: {},
	methods: {
		addCredit(payment) {
			if (payment.currencyId == this.Dong) {
				this.$set(
					this.customer,
					"dongCredit",
					this.customer.dongCredit + payment.amount
				);
			}
			if (payment.currencyId == this.Dollar) {
				this.$set(
					this.customer,
					"dollarCredit",
					this.customer.dollarCredit + payment.amount
				);
			}
		},
		generateInvoiceCsv() {
			eventBus.$emit("generateInvoiceCsv");
		},
		getUpdateForm() {
			this.isUpdating = true;
			this.isLoading = true;
			this.getCustomerById(this.$route.params.id);
		},
		getCustomerById(id) {
			backendService
				.getCustomerById(id)
				.then((response) => {
					this.customer = response.data;
					this.timer(1000).then(() => {
						this.isLoading = false;
					});
				})
				.catch(() => {
					this.timer(1000).then(() => {
						this.isLoading = false;
					});
				});
		},

		newInvoice() {
			this.$router.push({
				name: "NewInvoice",
				params: { customerId: this.customer.id, isGenerating: true },
			});
		},
	},
	watch: {
		"$route.params.id": function (newVal, oldVal) {
			if (newVal != oldVal) this.getUpdateForm();
		},
	},
	destroyed: function () {
		eventBus.$off("generateInvoiceCsv");
	},
};
</script>
<style scoped>
.customer-detail-header {
  gap: 12px;
  padding-bottom: 12px;
  padding-top: 12px;
}
.customer-summary {
  min-width: 0;
}
.customer-title {
  align-items: baseline;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.customer-id {
  font-size: 18px;
  font-weight: 600;
}
.customer-meta {
  align-items: center;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  gap: 8px;
  line-height: 1.4;
  margin-top: 4px;
}
.meta-divider {
  color: rgba(0, 0, 0, 0.28);
}
.parent-customer a {
  font-weight: 500;
}
.customer-actions {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}
</style>
